module.exports = {
  Actions: {
    next: 'Weiter',
    Congratulations: 'Vielen Dank!'
  },

  Validation: {
    genericError: 'Ungültiger Wert'
  }
}

